import { isBankDebitPaymentMethod, PaymentMethod } from "@simplyk/common";

import { TranslationKey, useTranslate } from "@/common/hooks/useTranslate";

const BANK_DEBIT_PAYMENT_METHOD_LABEL_KEYS: Partial<Record<PaymentMethod, TranslationKey<"common">>> = {
  [PaymentMethod.Ach]: "paymentMethod.ach",
  [PaymentMethod.Pad]: "paymentMethod.pad",
  [PaymentMethod.Sepa]: "paymentMethod.sepa",
};

export const useBankDebitPaymentMethodLabel = (allowedPaymentMethods: PaymentMethod[]): string => {
  const { t } = useTranslate();
  const bankDebitPaymentMethod = allowedPaymentMethods.find(isBankDebitPaymentMethod);
  const labelKey = bankDebitPaymentMethod && BANK_DEBIT_PAYMENT_METHOD_LABEL_KEYS[bankDebitPaymentMethod];

  return labelKey ? t("common", labelKey) : "";
};
